export const EQUIPEMENT_INTERVENTIONS = {
    SET_ITEMS: 'SET_SUIVI_EQUIPEMENT_INTERVENTIONS_ITEMS',
    SET_ALL_ITEMS: 'SET_ALL_SUIVI_EQUIPEMENT_INTERVENTIONS_ITEMS',
    RESET_ITEMS: 'RESET_SUIVI_EQUIPEMENT_INTERVENTIONS_ITEMS',
    ADD_ITEMS: 'ADD_SUIVI_EQUIPEMENT_INTERVENTIONS_ITEMS',
    ADD_ALL_ITEMS: 'ADD_ALL_SUIVI_EQUIPEMENT_INTERVENTIONS_ITEMS',

    SET_ACTIVE: 'SET_ACTIVE_SUIVI_EQUIPEMENT_INTERVENTIONS',
    SET_EQUIPEMENT_ID: 'SET_EQUIPEMENT_ID_SUIVI_EQUIPEMENT_INTERVENTIONS',

    SET_PAGE: 'SET_SUIVI_EQUIPEMENT_INTERVENTIONS_PAGE',
    SET_NB_OF_PAGES: 'SET_SUIVI_EQUIPEMENT_INTERVENTIONS_NB_OF_PAGES',
    SET_SCROLL: 'SET_SUIVI_EQUIPEMENT_INTERVENTIONS_SCROLL',
    SET_COUNT: 'SET_SUIVI_EQUIPEMENT_INTERVENTIONS_COUNT',

    SET_SORT: 'SET_DEMANDE_EQUIPEMENT_INTERVENTIONS_SORT',
    SET_FILTER_DATE_DEBUT: 'SUIVI_EQUIPEMENT_INTERVENTIONS_SET_FILTER_DATE_DEBUT',
    SET_FILTER_DATE_FIN: 'SUIVI_EQUIPEMENT_INTERVENTIONS_SET_FILTER_DATE_FIN',

    SET_IS_LOADING: 'SET_SUIVI_EQUIPEMENT_INTERVENTIONS_IS_LOADING',
    SET_ERROR: 'SET_SUIVI_EQUIPEMENT_INTERVENTIONS_ERROR',

    RESET: 'RESET_SUIVI_EQUIPEMENT_INTERVENTIONS'
};
